'use client'

import {SanityImageType} from '@local/types'
import {SanityImage, SmallText} from '@local/ui/components'
import clsx from 'clsx'
import Link from 'next/link'

export interface NewsCardProps {
	className?: string
	tag: string,
	date: string,
	isLarge?: boolean,
	item: {
		content: {
			surtitle: string,
			title: string,
			text: string,
		},
		image: SanityImageType,
		slug: {
			current: string
		},
	}
}

export const NewsCard = ({item, isLarge}: NewsCardProps) => {
	return (
		<Link href={`/article/${item.slug.current}`}>
			<article className={clsx('py-20 lg:span-w-3', {
				'lg:span-w-6': isLarge,
			})}>
				<SanityImage
					image={item.image}
					width={336}
					height={isLarge ? 215 : 440}
					desktopWidth={336}
					mobileWidth={203}
					className='rounded-lg w-full' />
				<div className='flex py-10 flex-col justify-between  gap-12  '>
					<SmallText className='uppercase text-grey-1'>5 min Read</SmallText>
					<h3 className='text-16 min-h-60 lg:span-w-2-wider lg:text-18 leading-tight font-serif tracking-tight capilatize text-grey-4'>{item.content.title}</h3>
					<p className='font-[350] text-12 lg:text-14 text-grey-4 leading-normal tracking-snug'>{item.content.text}</p>
				</div>
			</article>
		</Link>
	)
}
